/*
 * @Author: changcheng 364000100@#qq.com
 * @Date: 2025-07-07 15:35:54
 * @LastEditors: changcheng 364000100@#qq.com
 * @LastEditTime: 2025-07-10 15:43:38
 * @FilePath: /mvw_project/project_login_frontend/src/page/component/signupFloat/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState } from "react";
import { Modal, Button } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import Signup from "../signup";
import "./index.scss";

const SignupFloat = () => {
  const [visible, setVisible] = useState(false);

  // 处理报名提交
  const handleSignupSubmit = (result: any) => {
    console.log("报名结果:", result);
    // 报名成功后关闭弹窗
    if (result && result.code === 0) {
      setTimeout(() => {
        setVisible(false);
      }, 1500); // 延迟关闭，让用户看到成功提示
    }
  };

  return (
    <>
      {/* 报名弹窗 */}
      <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        title={
          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            报名
          </div>
        }
        destroyOnClose
        width={450}
        className="signup-modal"
      >
        <Signup onSubmit={handleSignupSubmit} />
      </Modal>
    </>
  );
};

export default SignupFloat;
